import { API_BASE_URL } from './index';
import { callApi } from 'utils/callApi';

export const getCommonPageDataListRequest = ({ search, sortOrder, page, limit }) =>
    callApi({
        requestFunction: (axios) =>
            axios.post(`${API_BASE_URL}/web/common-pages/folders`, {
                search,
                sorted: sortOrder,
                limit,
                page
            }),
        successCode: 200,
        showToastOnSuccess: false,
        showToastOnError: true
    });

export const importCommonPageDataRequest = ({ titles }) =>
    callApi({
        requestFunction: (axios) =>
            axios.post(`${API_BASE_URL}/web/common-pages/folders/import`, {
                folders: titles
            }),
        successCode: 201
    });

export const saveCommonPageDataAssetsRequest = (payload) =>
    callApi({
        requestFunction: (axios) => axios.post(`${API_BASE_URL}/web/common-pages/folders/assets/add`, payload),
        successCode: 200,
        showToastOnSuccess: true,
        showToastOnError: true
    });

export const getCommonPageDataAssetsRequest = (id) =>
    callApi({
        requestFunction: (axios) => axios.get(`${API_BASE_URL}/web/common-pages/folders/${id}`),
        successCode: 200,
        showToastOnSuccess: false,
        showToastOnError: true
    });

export const deleteFolderAssetRequest = (folderId, assetId) =>
    callApi({
        requestFunction: (axios) => axios.delete(`${API_BASE_URL}/web/common-pages/folders/${folderId}/${assetId}`),
        successCode: 200,
        showToastOnSuccess: true,
        showToastOnError: true
    });

export const deleteFolderRequest = ({ folderId }) =>
    callApi({
        requestFunction: (axios) => axios.delete(`${API_BASE_URL}/web/common-pages/folders/${folderId}`),
        successCode: 200,
        showToastOnSuccess: true,
        showToastOnError: true
    });
